import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ChangePinState {
  loading: boolean;
  activatePinSuccess: any;
  activatePinError: any | null;
  changePinSuccess: any;
  changePinError: any | null;
}

const initialState: ChangePinState = {
  loading: false,
  activatePinSuccess: null,
  activatePinError: null,
  changePinSuccess: null,
  changePinError: null,
};

const changePinSlice = createSlice({
  name: 'changePin',
  initialState,
  reducers: {
    activateCardRequest(state, action) {
      state.loading = true;
      state.activatePinSuccess = null;
      state.activatePinError = null;
    },
    activateCardSuccess(state, action) {
      state.loading = false;
      state.activatePinSuccess = action.payload;
      state.activatePinError = null;
    },
    activateCardFailed(state, action) {
      state.loading = false;
      state.activatePinSuccess = null;
      state.activatePinError = action.payload;
    },
    changePinRequest(state, action) {
      state.loading = true;
      state.changePinSuccess = null;
      state.changePinError = null;
    },
    changePinSuccess(state, action) {
      state.loading = false;
      state.changePinSuccess = action.payload;
      state.changePinError = null;
    },
    changePinFailed(state, action) {
      state.loading = false;
      state.changePinSuccess = null;
      state.changePinError = action.payload;
    },
    resetChangePinState(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const {
  activateCardRequest,
  activateCardSuccess,
  activateCardFailed,
  changePinRequest,
  changePinSuccess,
  changePinFailed,
  resetChangePinState,
} = changePinSlice.actions;

export default changePinSlice.reducer;
